// This file contains getters for AB test group values. Functions should be removed from here as AB tests finish. An template for a function is below:
//
// export function getNameOfTestValue() {
//   return getABTestGroup(
//     'NameOfTest',
//     [
//       { choice: 'CONTROL', weight: 1 },
//       { choice: 'VARIANT1', weight: 1 },
//       { choice: 'VARIANT2', weight: 1 },
//       { choice: 'VARIANT3', weight: 1 },
//     ]
//   );
// }

import { getABTestGroup } from "./shared/getABTestGroup";

export function getEnterFlowProgressValue() {
  return getABTestGroup(
    'EnterFlowProgress',
    [
      { choice: 'CONTROL', weight: 1 },
      { choice: 'VARIANT1', weight: 1 },
      { choice: 'VARIANT2', weight: 0 },
      { choice: 'VARIANT3', weight: 0 },
    ]
  );
}


export function getChooseYourPlanDec2025Value() {
  return getABTestGroup(
    'ChooseYourPlanDec2025',
    [
      { choice: 'CONTROL', weight: 1 },
      { choice: 'VARIANT1', weight: 0 },
      { choice: 'VARIANT2', weight: 0 },
    ]
  );
}

export function getHomePageHeroTextSep2025Value() {
  return getABTestGroup(
    'HomePageHeroTextSep2025',
    [
      { choice: 'CONTROL', weight: 1 },
      { choice: 'V1', weight: 1 },
      { choice: 'V2', weight: 0 },
      { choice: 'V3', weight: 1 },
      { choice: 'V4', weight: 0 },
      { choice: 'V5', weight: 0 },
      { choice: 'V6', weight: 1 },
      { choice: 'V7', weight: 0 },
      { choice: 'V8', weight: 1 },
    ]
  );
}

export function getZendeskChatBotTestValue() {
  return getABTestGroup(
    'ZendeskChatBot',
    [
      { choice: 'CONTROL', weight: 0.75 },
      { choice: 'CHATBOT', weight: 0.25 },
    ]
  );
}